import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndoorWorldSeriesAmateurRankingRoutingModule } from './indoor-world-series-amateur-ranking-routing.module';
import { SeriesAmateurRankingComponent } from './series-amateur-ranking/series-amateur-ranking.component';
import { SeriesAmateurRankingInfoComponent } from './series-amateur-ranking-info/series-amateur-ranking-info.component';
import { SeriesAmateurRankingFiltersComponent } from './series-amateur-ranking-filters/series-amateur-ranking-filters.component';
import { SeriesAmateurRankingListComponent } from './series-amateur-ranking-list/series-amateur-ranking-list.component';
import { CoreModule } from 'world-archery-lib';
import { IndoorAmateurBootstrapComponent } from './indoor-amateur-bootstrap/indoor-amateur-bootstrap.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { HttpClient } from '@angular/common/http';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';

@NgModule({
  bootstrap: [
    IndoorAmateurBootstrapComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    CoreModule,
    IndoorWorldSeriesAmateurRankingRoutingModule,
    CommonPageComponentsModule
  ],
  declarations: [
    SeriesAmateurRankingComponent,
    SeriesAmateurRankingInfoComponent,
    SeriesAmateurRankingFiltersComponent,
    SeriesAmateurRankingListComponent,
    IndoorAmateurBootstrapComponent,
  ]
})
export class IndoorWorldSeriesAmateurRankingModule {
    constructor(){
    }
 }
